import get from 'lodash/get';
import { api } from '../../api';
import { actions } from '../../../store/actions';

export const editCustomerInfo = (
  values,
  toggleEdit,
  setErrors,
  setSubmitting,
) => async dispatch => {
  try {
    await api.editCustomerInfo(values);
    if (values.oldPassword) {
      await api.changePassword(values);
    }
    localStorage.setItem('firstName', values.firstName);
    localStorage.setItem('lastName', values.lastName);
    dispatch(actions.editCustomerInfo.act(values));
    toggleEdit();
  } catch (err) {
    setErrors({
      backError: get(err, ['response', 'data', 'errorMsg'], 'Unknown error'),
    });
    setSubmitting(false);
  }
};
